import React, { useState } from "react";
import loadable from "@loadable/component";

import underlineGraphic from "./../assets/icons/header-orange-underline.svg";
import playStoreImage from "./../assets/images/google-play.png";
import rigthArrowBlue from "./../assets/icons/blue-right-arrow.svg";
import { EXPLORE_JOB_APP } from "./../shared/constants/routing-constants";
import {
  useFreshersJobsHome,
  useGovtJobsHome,
  useJobCategoriesHome,
  useLatestJobsHome,
  useTopJobLocations,
} from "./../network/APIs/categories";
import { useNavigate } from "react-router";
import { createSearchParams, Link } from "react-router-dom";
//images
import jobLogo from "../assets/images/jobs_icon.png";
import studentLogo from "../assets/images/students_icon.png";
import gesia from "../assets/images/Gesia.png";
import iitkharagpur from "../assets/images/iitkharagpur3 (1).png";
import collegeprofileplaceholder from "../assets/images/college_profile_placeholder2.png";
import { useEngineerJobsList, useMbaJobsList } from "../network/APIs/jobs";
import {
  CheckCircle,
  Play,
  Briefcase,
  TrendingUp,
  ArrowRight,
  MoveRight,
  Building2,
  Users,
  GraduationCap,
  UserPlus,
  Building,
  Cpu,
  Globe,
  Rocket,
  ShieldCheck,
  Zap,
  Award,
  Landmark,
  Download,
  Sparkles,
  CheckCircle2,
  Heart,
  Smartphone,
} from "lucide-react";
import ihub from "./../assets/images/ihub.png";
import ssip from "./../assets/images/ssip.png";
import meity from "./../assets/images/meity.png";
import startup_india from "./../assets/images/startup_india.jpeg";
import nvidia from "./../assets/images/nvidia.webp";
import KSPCFE from "./../assets/images/KSPCFE.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Snackbar, Alert } from "@mui/material";

import Mumbai from "./../assets/images/Mumbai.png";
import Bangalore from "./../assets/images/Bangalore.png";
import Ahmedabad from "./../assets/images/Ahmedabad.png";
import Pune from "./../assets/images/Pune.png";
import Hyderabad from "./../assets/images/Hyderabad.jpg";
import DelhiNCR from "./../assets/images/Delhi NCR.png";

const Category = loadable(() => import("./../shared-components"), {
  resolveComponent: (components) => components.Category,
});

const GovJobs = loadable(() => import("./../shared-components"), {
  resolveComponent: (components) => components.GovJobs,
});

const LatestJobs = loadable(() => import("./../shared-components"), {
  resolveComponent: (components) => components.LatestJobs,
});

const SearchBar = loadable(() => import("./../shared-components"), {
  resolveComponent: (components) => components.SearchBar,
});

export const LOCATIONS = [
  {
    name: "Bangalore",
    count: "450+",
    id: 34,
    image: Bangalore,
  },
  {
    name: "Pune",
    count: "320+",
    id: 42,
    image: Pune,
  },
  {
    name: "Hyderabad",
    count: "280+",
    id: 50,
    image: Hyderabad,
  },
  {
    name: "Mumbai",
    count: "500+",
    id: 40,
    image: Mumbai,
  },
  {
    name: "Delhi NCR",
    count: "350+",
    id: 56,
    image: DelhiNCR,
  },
  {
    name: "Ahmedabad",
    count: "1.2k+",
    id: 1,
    image: Ahmedabad,
  },
];
// old one with links
// const LOCATIONS = [
//   {
//     name: "Bangalore",
//     count: "450+",
//     id: 34,
//     image:
//       "https://images.unsplash.com/photo-1596176530529-78163a4f7af2?auto=format&fit=crop&q=80&w=200&h=200",
//   },
//   {
//     name: "Pune",
//     count: "320+",
//     id: 42,
//     image:
//       "https://images.unsplash.com/photo-1582298539106-25e2b02867f0?auto=format&fit=crop&q=80&w=200&h=200",
//   },
//   {
//     name: "Hyderabad",
//     count: "280+",
//     id: 50,
//     image:
//       "https://images.unsplash.com/photo-1605218427368-35b85073e838?auto=format&fit=crop&q=80&w=200&h=200",
//   },
//   {
//     name: "Mumbai",
//     count: "500+",
//     id: 40,
//     image:
//       "https://images.unsplash.com/photo-1570168007204-dfb528c6958f?auto=format&fit=crop&q=80&w=200&h=200",
//   },
//   {
//     name: "Delhi NCR",
//     count: "350+",
//     id: 56,
//     image:
//       "https://images.unsplash.com/photo-1587474260584-136574528615?auto=format&fit=crop&q=80&w=200&h=200",
//   },
//   {
//     name: "Ahmedabad",
//     count: "1.2k+",
//     id: 1,
//     image:
//       "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=200&h=200",
//   },
// ];

const PARTNERS = [
  { id: 1, name: "iHub Incubation", icon: Building2 },
  { id: 2, name: "SSIP Gujarat", icon: ShieldCheck },
  { id: 3, name: "GTU Ventures", icon: Rocket },
  { id: 4, name: "NVIDIA", icon: Cpu },
  { id: 5, name: "Startup India", icon: Globe },
  { id: 6, name: "Digital India", icon: Zap },
  { id: 7, name: "NASSCOM", icon: Award },
  { id: 8, name: "Govt. of India", icon: Landmark },
];

const PLATFORM_STATS = [
  {
    id: "1",
    value: "3,000+",
    label: "Colleges Connected",
    icon: GraduationCap,
  },
  { id: "2", value: "2 Lakh+", label: "Freshers Onboarded", icon: Users },
  { id: "3", value: "1,000+", label: "Companies Hiring", icon: Building2 },
];

const glanceItems = [
  {
    value: "1,00,000+",
    label: "App Downloads",
    subtitle: "On Google Play Store",
    icon: Smartphone,
    color: "text-blue-600 bg-blue-50 border-blue-100",
  },
  {
    value: "2,00,000+",
    label: "Students Connected",
    subtitle: "Active candidates",
    icon: Users,
    color: "text-indigo-600 bg-indigo-50 border-indigo-100",
  },
  {
    value: "3,000+",
    label: "Colleges Network Reach",
    subtitle: "Underserved regional reach",
    icon: GraduationCap,
    color: "text-violet-600 bg-violet-50 border-violet-100",
  },
  {
    value: "200+",
    label: "Startups Onboarded",
    subtitle: "Rapidly scaling recruiters",
    icon: Rocket,
    color: "text-rose-600 bg-rose-50 border-rose-100",
  },
  {
    value: "25,000+",
    label: "Job Applications",
    subtitle: "Facilitated successfully",
    icon: Briefcase,
    color: "text-emerald-600 bg-emerald-50 border-emerald-100",
  },
  {
    value: "AI-Powered",
    label: "Career & Employability",
    subtitle: "Pathways & intelligent matching",
    icon: Cpu,
    color: "text-amber-600 bg-amber-50 border-amber-100",
  },
  {
    value: "Tier 2 & 3",
    label: "Students Empowered",
    subtitle: "Bridging opportunity gaps",
    icon: Globe,
    color: "text-cyan-600 bg-cyan-50 border-cyan-100",
  },
];

const recognitionItems = [
  {
    title: "Ecosystem Incubation",
    description:
      "Supported by iHub Gujarat, K S Patel Centre for Entrepreneurship, and SSIP (SGGU).",
    badge: "SSIP, Srujan and GENESIS EIR Support",
    colorClass: "border-emerald-100 bg-emerald-50/40 text-emerald-800",
  },
  {
    title: "State Level Collaboration",
    description:
      "Collaboration with Startup Odisha Ecosystem to enhance regional opportunities.",
    badge: "Odisha Startup Partner",
    colorClass: "border-blue-100 bg-blue-50/40 text-blue-800",
  },
  {
    title: "Media & Platform Features",
    description:
      "Featured in Divyabhaskar Positive Story and Zoho Startup Case Study.",
    badge: "Media Feature",
    colorClass: "border-indigo-100 bg-indigo-50/40 text-indigo-800",
  },
  {
    title: "Trusted Framework",
    description:
      "AI-Powered Employability Platform loved by students, colleges & startups alike.",
    badge: "Verified Employability",
    colorClass: "border-amber-100 bg-amber-50/40 text-amber-800",
  },
  {
    title: "UN SDG Alignment",
    description:
      "Driving real-world impact across UN SDG 4 (Quality Education), SDG 8 & SDG 10.",
    badge: "Impact Aligned",
    colorClass: "border-rose-100 bg-rose-50/40 text-rose-800",
  },
];

const features = [
  {
    id: 1,
    title: "100% Verified Jobs",
    description:
      "We manually verify every job posting to ensure a scam-free experience.",
    icon: ShieldCheck,
    color: "text-emerald-600",
    bg: "bg-emerald-50",
    border: "hover:border-emerald-200",
  },
  {
    id: 2,
    title: "Fresher-First Platform",
    description:
      "Designed exclusively for early talent. No experience? No problem.",
    icon: GraduationCap,
    color: "text-blue-600",
    bg: "bg-blue-50",
    border: "hover:border-blue-200",
  },
  {
    id: 3,
    title: "Direct HR Connect",
    description:
      "Skip the consultants. Connect directly with HRs from top Startups.",
    icon: Users,
    color: "text-indigo-600",
    bg: "bg-indigo-50",
    border: "hover:border-indigo-200",
  },
  {
    id: 4,
    title: "Smart Job Matching",
    description:
      "Our AI matches your skills to the perfect job opportunities instantly.",
    icon: Zap,
    color: "text-amber-600",
    bg: "bg-amber-50",
    border: "hover:border-amber-200",
  },
];

// function HomePage() {
//   const jobsCategories = useJobCategoriesHome();
//   const govtJobs = useGovtJobsHome();
//   const feshersJobs = useFreshersJobsHome();
//   const latestJobs = useLatestJobsHome();
//   const engineerJobs = useEngineerJobsList();
//   const mbaJobs = useMbaJobsList();

//   const navigate = useNavigate();

//   const searchHandler = (search: string) => {
//     if (search && search.trim()) {
//       navigate({
//         pathname: `${EXPLORE_JOB_APP}`,
//         search: `?${createSearchParams({
//           search: search.trim(),
//         })}`,
//       });
//     }
//   };

//   return (
//     <>
//       {/* Header Starts */}
//       <div
//         style={{
//           backgroundPosition: "100% 42%",
//         }}
//         className="px-[124px] pt-[88px] pb-[40px] bg-[#F8F8FD] bg-no-repeat sm:bg-none sm:px-[40px] bg-homepage"
//       >
//         <h1 className="text-[72px] sm:text-[50px] font-[700] leading-[79px] sm:leading-[59px] max-w-[360px] mb-[30px] font-DmSans">
//           Mission to Boost{" "}
//           <span className="text-[#FF5F14] font-DmSans">Employment</span>
//         </h1>
//         <img
//           loading="lazy"
//           src={underlineGraphic}
//           alt="bg-graphic"
//           className="mb-[20px] w-[400px] sm:hidden"
//         />
//         <p className="text-[20px] sm:text-[16px] text-[#515B6F] max-w-[540px] mb-[45px]">
//           Freshment is India's leading Job Portal - Search & Apply for Latest
//           Job Vacancies across Top Companies in India, Employers can Post Job &
//           Hire Candidates for Free
//         </p>
//         <div className="flex sm:flex-col-reverse">
//           <Link
//             to={
//               "https://play.google.com/store/apps/details?id=com.govtjobs.naukari"
//             }
//             target="_blank"
//           >
//             <img
//               loading="lazy"
//               src={playStoreImage}
//               alt="google play"
//               height={70}
//               className="mr-[30px] h-[70px] sm:h-[40px] cursor-pointer"
//             />
//           </Link>
//           <p className="text-[20px] text-[#515B6F] max-w-[370px] mb-[45px]">
//             Join Over
//             <span className="text-[#FF5F14] font-bold"> 1.25 Lakh+</span> Freshers
//             Finding Their Dream Careers on Freshment!
//           </p>
//         </div>
//         <div className="max-w-[852px]">
//           <SearchBar
//             handleSearch={searchHandler}
//             placeholder="Job title or keyword"
//             subtitle="Popular : AI/ML, Finance, Mechanical, Electrical, Civil, Marketing"
//           />
//         </div>
//       </div>
//       {/* Header Ends */}

//       <div className="px-[124px] sm:px-[40px]">
//         <div className="mt-[80px] sm:mt-[60px]">
//           <div className="text-[48px] sm:text-[30px] font-[700] mb-[48px] flex justify-between items-center">
//             <p className="text-[#25324B] font-DmSans">
//               Explore by{" "}
//               <span className="text-[#FF5F14] font-DmSans"> category</span>
//             </p>
//             <Link
//               to="/explore-job"
//               className="text-[#2670FF] text-[16px] flex gap-[16px] sm:gap-[6px]"
//             >
//               Show all jobs{" "}
//               <img
//                 loading="lazy"
//                 alt="right arrow"
//                 src={rigthArrowBlue}
//                 height="24"
//                 width="24"
//               />
//             </Link>
//           </div>
//           <div className="grid grid-cols-4 gap-[32px] xsm:grid-cols-1 sm:grid-cols-2  sm:gap-[20px]">
//             {jobsCategories.data?.map((category) => {
//               return <Category {...category} key={category.id} />;
//             })}
//           </div>
//         </div>

//         <div className="w-full mt-[80px] mb-[72px]">
//           <footer className="footer">
//             <div className="footer-container">
//               <div className="footer-row">
//                 <div className="left-footer">
//                   <p className="left-footer-title">
//                     Featured In GESIA, IIT-Kharagpur Top 5 Emerging Start-ups
//                   </p>
//                   <div className="left-footer-content">
//                     <div className="left-footer-images">
//                       <img
//                         className="footer-image img-left"
//                         src={iitkharagpur}
//                         alt="IIT Kharagpur Logo"
//                       />
//                       <img
//                         className="footer-image img-left-small"
//                         src={gesia}
//                         alt="GESIA Logo"
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="right-footer">
//                   <p className="right-footer-title">
//                     Trusted by 2500+ Colleges & 50+ Universities
//                   </p>
//                   <div className="right-footer-content">
//                     <div className="right-footer-item">
//                       <img
//                         className="footer-image"
//                         src={studentLogo}
//                         alt="Students Icon"
//                       />
//                       <div className="footer-text">
//                         <p className="footer-bold">1.25 Lakh+</p>
//                         <p className="footer-subtext">Users</p>
//                       </div>
//                     </div>
//                     <div className="right-footer-item">
//                       <img
//                         className="footer-image"
//                         src={jobLogo}
//                         alt="Jobs Icon"
//                       />
//                       <div className="footer-text">
//                         <p className="footer-bold">5000+</p>
//                         <p className="footer-subtext">Jobs</p>
//                       </div>
//                     </div>
//                     <div className="right-footer-item">
//                       <img
//                         className="footer-image img-large"
//                         src={collegeprofileplaceholder}
//                         alt="Colleges Icon"
//                       />
//                       <div className="footer-text">
//                         <p className="footer-bold">2500+</p>
//                         <p className="footer-subtext">Colleges</p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </footer>
//         </div>

//         <div className="mt-[80px] mb-[72px]">
//           <div className="text-[48px] sm:text-[30px] font-[700] mb-[48px] flex justify-between items-center">
//             <p className="text-[#25324B] font-DmSans">
//               Trending
//               <span className="text-[#FF5F14] font-DmSans">
//                 {" "}
//                 Tech/AI-ML jobs
//               </span>
//             </p>
//             <Link
//               to="/freshers-job"
//               className="text-[#2670FF] text-[16px] flex gap-[16px] sm:gap-[6px]"
//             >
//               Show all jobs{" "}
//               <img
//                 loading="lazy"
//                 alt="right arrow"
//                 src={rigthArrowBlue}
//                 height="24"
//                 width="24"
//               />
//             </Link>
//           </div>

//           <div className="grid grid-cols-4 gap-[32px] xsm:grid-cols-1 sm:grid-cols-2 sm  sm:gap-[20px]">
//             {feshersJobs.data?.map((job) => {
//               return <GovJobs {...job} key={job.id} />;
//             })}
//           </div>
//         </div>
//         <div className="mt-[80px] mb-[72px]">
//           <div className="text-[48px] sm:text-[30px] font-[700] mb-[48px] flex justify-between items-center">
//             <p className="text-[#25324B] font-DmSans">
//               Trending
//               <span className="text-[#FF5F14] font-DmSans">
//                 {" "}
//                 Core Engg/Embedded jobs
//               </span>
//             </p>
//             <Link
//               to="/freshers-job"
//               className="text-[#2670FF] text-[16px] flex gap-[16px] sm:gap-[6px]"
//             >
//               Show all jobs{" "}
//               <img
//                 loading="lazy"
//                 alt="right arrow"
//                 src={rigthArrowBlue}
//                 height="24"
//                 width="24"
//               />
//             </Link>
//           </div>

//           <div className="grid grid-cols-4 gap-[32px] xsm:grid-cols-1 sm:grid-cols-2 sm  sm:gap-[20px]">
//             {engineerJobs?.data?.data?.map((job) => {
//               return <GovJobs {...job} key={job.id} />;
//             })}
//           </div>
//         </div>
//         <div className="mt-[80px] mb-[72px]">
//           <div className="text-[48px] sm:text-[30px] font-[700] mb-[48px] flex justify-between items-center">
//             <p className="text-[#25324B] font-DmSans">
//               Trending
//               <span className="text-[#FF5F14] font-DmSans">
//                 {" "}
//                 MBA/Commerce jobs
//               </span>
//             </p>
//             <Link
//               to="/freshers-job"
//               className="text-[#2670FF] text-[16px] flex gap-[16px] sm:gap-[6px]"
//             >
//               Show all jobs{" "}
//               <img
//                 loading="lazy"
//                 alt="right arrow"
//                 src={rigthArrowBlue}
//                 height="24"
//                 width="24"
//               />
//             </Link>
//           </div>

//           <div className="grid grid-cols-4 gap-[32px] xsm:grid-cols-1 sm:grid-cols-2 sm  sm:gap-[20px]">
//             {mbaJobs?.data?.data?.map((job) => {
//               return <GovJobs {...job} key={job.id} />;
//             })}
//           </div>
//         </div>
//       </div>

//       {/* Latest Jobs */}
//       <div
//         className="px-[124px] sm:px-[40px] pt-[72px] pb-[60px]"
//         style={{
//           backgroundColor: "#F8F8FD",
//         }}
//       >
//         <div className="text-[48px] sm:text-[30px] font-[700] mb-[48px] flex justify-between items-center">
//           <p className="text-[#25324B] font-DmSans">
//             Latest{" "}
//             <span className="text-[#FF5F14] font-DmSans"> jobs open</span>
//           </p>
//           <Link
//             to="/freshers-job"
//             className="text-[#2670FF] text-[16px] flex gap-[16px] sm:gap-[6px]"
//           >
//             Show all jobs{" "}
//             <img
//               loading="lazy"
//               alt="right arrow"
//               src={rigthArrowBlue}
//               height="24"
//               width="24"
//             />
//           </Link>
//         </div>
//         <div className="grid grid-cols-2 gap-x-[32px] gap-y-[16px] sm:grid-cols-1 sm:gap-y-[14px]">
//           {latestJobs.data?.map((job) => {
//             return <LatestJobs {...job} key={job.id} />;
//           })}
//         </div>
//       </div>
//       <div className="mt-[80px] mb-[72px] px-[124px] sm:px-[40px] ">
//         <div className="text-[48px] sm:text-[30px] font-[700] mb-[48px] flex justify-between items-center">
//           <p className="text-[#25324B] font-DmSans">
//             Public Sector
//             <span className="text-[#FF5F14] font-DmSans"> jobs</span>
//           </p>
//           <Link
//             to="/government-job"
//             className="text-[#2670FF] text-[16px] flex gap-[16px] sm:gap-[6px]"
//           >
//             Show all jobs{" "}
//             <img
//               loading="lazy"
//               alt="right arrow"
//               src={rigthArrowBlue}
//               height="24"
//               width="24"
//             />
//           </Link>
//         </div>

//         <div className="grid grid-cols-4 gap-[32px] sm:grid-cols-1 sm:gap-[20px]">
//           {govtJobs.data?.map((job) => {
//             return <GovJobs {...job} key={job.id} />;
//           })}
//         </div>
//       </div>
//     </>
//   );
// }

const companies = [
  "Bignano Ventures",
  "EarthaShastra",
  "Joyspoon",
  "Curio",
  "Picnify.in",
];

function HomePage() {
  const jobsCategories = useJobCategoriesHome();
  const govtJobs = useGovtJobsHome();
  const feshersJobs = useFreshersJobsHome();
  const latestJobs = useLatestJobsHome();
  const engineerJobs = useEngineerJobsList();
  const mbaJobs = useMbaJobsList();
  const topJobLocations = useTopJobLocations();

  // Snackbar State
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<
    "success" | "error" | "info" | "warning"
  >("success");

  const handleCloseSnackbar = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const showSnackbar = (
    message: string,
    severity: "success" | "error" | "info" | "warning" = "success",
  ) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };

  // console.log("job category ", jobsCategories);
  // console.log("fresherjobs ", feshersJobs);

  const navigate = useNavigate();

  const searchHandler = (search: string) => {
    if (search && search.trim()) {
      navigate({
        pathname: `${EXPLORE_JOB_APP}`,
        search: `?${createSearchParams({
          search: search.trim(),
        })}`,
      });
    } else {
      showSnackbar("Please enter a search query", "error");
    }
  };

  const supporters = [
    { name: "AWS", color: "#f59e0b", hoverBg: "#fffbeb" },
    { name: "Google Cloud", color: "#3b82f6", hoverBg: "#eff6ff" },
    { name: "NVIDIA", color: "#16a34a", hoverBg: "#f0fdf4" },
    { name: "iHub", color: "#4f46e5", hoverBg: "#eef2ff" },
    { name: "MeitY", color: "#1e3a8a", hoverBg: "#dbeafe" },
    { name: "SISF", color: "#e11d48", hoverBg: "#fff1f2" },
  ];
  const supportersImage = [
    { name: "ihub", src: ihub },
    { name: "ssip", src: ssip },
    { name: "meity", src: meity },
    { name: "nvidia", src: nvidia },
    { name: "KSPCFE", src: KSPCFE },
    { name: "startup_india", src: startup_india },
  ];

  return (
    <div className="leading-relaxed">
      {/* hero style */}
      <section className="relative bg-white pt-20 xl:pt-12 pb-24 xl:pb-18 overflow-hidden">
        {/* Abstract Background Shapes */}
        <div className="absolute top-0 right-0 -mr-20 -mt-20 w-[600px] h-[600px] bg-gradient-to-bl from-blue-50 to-white rounded-full blur-3xl opacity-50 -z-10"></div>
        <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-[500px] h-[500px] bg-gradient-to-tr from-indigo-50 to-white rounded-full blur-3xl opacity-50 -z-10"></div>

        {/* Grid Pattern Overlay */}
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 -z-10"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 xsm:px-8 relative">
          <div className="grid grid-cols-2 sm:grid-cols-1 gap-16 sm:gap-12 items-center">
            {/* Left Column: Content */}
            <div className="text-left sm:text-center max-w-2xl mx-0 sm:mx-auto">
              {/* Badge */}
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold uppercase tracking-widest mb-8 hover:bg-blue-100 transition-colors cursor-default">
                <span className="flex h-2 w-2 relative">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-600"></span>
                </span>
                AI-Powered Career & Employability Platform
              </div>

              {/* Headline */}
              <h1 className="text-6xl xl:text-5xl sm:text-4xl font-black text-slate-900 tracking-tight leading-[1.1] mb-6">
                Transforming Education into{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                  Livelihood Opportunities
                </span>
              </h1>

              {/* Subtext */}
              <p
                className="text-slate-500 mb-10  pr-4"
                style={{
                  fontSize: "1.25rem",
                  lineHeight: "1.6",
                  fontWeight: 500,
                }}
              >
                AI-powered career pathways, internships, and hiring solutions
                helping 2,00,000+ students, 3,000+ colleges, and 200+ startups
                build the future workforce of India.
              </p>

              {/* Modern Simplified Search Bar */}
              <SearchBar
                handleSearch={searchHandler}
                placeholder="Job title, skills, or company... "
              />

              {/* Trust Badges */}
              <div className="flex flex-wrap justify-start sm:justify-center gap-x-8 gap-y-3 text-sm font-semibold text-slate-500 mb-10">
                <div className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-green-500" />
                  <span>Verified Jobs</span>
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-green-500" />
                  <span>Free for Employers</span>
                </div>
              </div>

              {/* App Store Buttons */}

              <div className="flex items-center justify-start sm:justify-center gap-4">
                <Link
                  to={
                    "https://play.google.com/store/apps/details?id=com.govtjobs.naukari"
                  }
                  target="_blank"
                >
                  <button className="flex items-center gap-3 bg-slate-900 text-white px-5 py-2.5 rounded-xl hover:bg-slate-800 transition shadow-xl hover:-translate-y-0.5">
                    <Play className="w-6 h-6 fill-current" />
                    <div className="text-left">
                      <div className="text-[10px] uppercase font-bold text-gray-400 leading-none mb-0.5">
                        Get it on
                      </div>
                      <div className="text-sm font-bold leading-none">
                        Google Play
                      </div>
                    </div>
                  </button>
                </Link>
                <div className="text-xs text-gray-400 font-medium max-w-[100px] leading-tight">
                  Join 2 Lakh+ Freshers
                </div>
              </div>
            </div>

            {/* Right Column: Visuals */}
            <div className="relative h-[600px] xl:h-auto flex items-center justify-end xl:justify-center z-10 mt-0 xl:mt-12">
              {/* Main Hero Image with Blob Mask effect visually */}
              <div className="relative w-[450px] sm:w-[350px] aspect-[4/5] bg-gray-100 rounded-[3rem] overflow-hidden shadow-2xl border-8 border-white">
                <img
                  src="https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&q=80&w=1770"
                  alt="Happy Graduates"
                  className="w-full h-full object-cover"
                />

                {/* Gradient Overlay at bottom */}
                <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-black/50 to-transparent"></div>
              </div>

              {/* Floating Element 1: Hired Notification */}
              <div className="absolute top-[15%] left-[20px] sm:left-[-10px] bg-white/90 backdrop-blur-md p-4 rounded-2xl shadow-[0_15px_40px_-10px_rgba(0,0,0,0.1)] border border-white flex items-center gap-3 animate-bounce [animation-duration:3s]">
                <div className="bg-green-100 p-2 rounded-full">
                  <Briefcase className="w-5 h-5 text-green-600" />
                </div>
                <div>
                  <p className="text-xs text-gray-500 font-bold uppercase">
                    Status
                  </p>
                  <p className="text-sm font-bold text-slate-900">
                    You're Hired! 🎉
                  </p>
                </div>
              </div>

              {/* Floating Element 2: Stats */}
              <div className="absolute bottom-[20%] right-0 sm:right-[-10px] bg-white/90 backdrop-blur-md p-4 rounded-2xl shadow-[0_15px_40px_-10px_rgba(0,0,0,0.1)] border border-white flex flex-col gap-1">
                <div className="flex items-center gap-2 mb-1">
                  <TrendingUp className="w-4 h-4 text-blue-600" />
                  <span className="text-xs font-bold text-slate-500 uppercase">
                    Growth
                  </span>
                </div>
                <div className="flex items-baseline gap-1">
                  <span className="text-2xl font-black text-slate-900">
                    1.2k+
                  </span>
                  <span className="text-xs text-gray-500 font-medium">
                    New Jobs
                  </span>
                </div>
                <div className="flex -space-x-2 mt-2">
                  {[1, 2, 3, 4].map((i) => (
                    <img
                      key={i}
                      className="w-7 h-7 rounded-full border-2 border-white"
                      src={`https://i.pravatar.cc/100?img=${i + 10}`}
                      alt="User"
                    />
                  ))}
                  <div className="w-7 h-7 rounded-full border-2 border-white bg-slate-100 flex items-center justify-center text-[10px] font-bold text-slate-500">
                    +
                  </div>
                </div>
              </div>

              {/* Background Decoration Elements behind image */}
              <div className="absolute -z-10 top-[10%] right-[10%] w-24 h-24 bg-yellow-400 rounded-full blur-2xl opacity-40"></div>
              <div className="absolute -z-10 bottom-[10%] left-[10%] w-32 h-32 bg-blue-600 rounded-full blur-3xl opacity-30"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Social Impact Banner */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 xsm:px-8">
        <div className="mb-16 bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-[2rem] p-12 xl:p-8  xsm:p-4 shadow-xl shadow-blue-900/10 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-white/5 rounded-full blur-[100px] pointer-events-none"></div>
          <div className="relative z-10 text-center space-y-4">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-white/10 text-brand-100 text-[10px] font-black uppercase tracking-wider rounded-md border border-white/10">
              <Heart className="w-3.5 h-3.5 text-rose-300 fill-rose-300" />{" "}
              Social Impact Initiative
            </span>
            <blockquote className="text-3xl xl:text-xl font-extrabold leading-tight tracking-tight text-white break-words">
              "Bridging the gap between Education and Employment for students
              from Tier 2 & Tier 3 Underserved Regions of India."
            </blockquote>
          </div>
        </div>
      </div>

      {/* Explore by category */}

      <section className="pt-14 bg-white relative">
        <div className="max-w-7xl mx-auto px-4 xl:px-6 sm:px-8">
          <div className="flex flex-row sm:justify-center justify-between items-end mb-12 px-2">
            <div>
              <div className="text-blue-600 font-bold text-sm tracking-wider uppercase mb-2">
                Discover Opportunities
              </div>
              <h2 className="text-4xl font-black text-slate-900 tracking-tight">
                Explore Jobs by <span className="text-blue-600">Category</span>
              </h2>
            </div>
            <Link
              to="/explore-job"
              className="flex sm:hidden items-center gap-2 text-slate-500 hover:text-blue-600 font-semibold transition-colors group"
            >
              View All Categories{" "}
              <MoveRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>

          <div className="grid grid-cols-6 xl:grid-cols-3 xsm:grid-cols-2 gap-6 xl:gap-4">
            {jobsCategories.data?.slice(0, 6).map((category) => {
              return <Category {...category} key={category.id} />;
            })}
          </div>

          {/* Mobile View All */}
          <div className="mt-8 text-center hidden sm:block">
            <Link
              to="/explore-job"
              className="inline-flex items-center gap-2 text-blue-600 font-bold"
            >
              View All Categories <MoveRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* Jobs by location*/}
      <section className="py-20 bg-white border-t border-slate-50">
        <div className="max-w-7xl mx-auto px-4 xl:px-6 sm:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-black text-slate-900 tracking-tight mb-2">
              Find Jobs <span className="text-blue-600">Near You</span>
            </h2>
            <p className="text-slate-500 font-medium">
              Explore opportunities in top cities across India
            </p>
          </div>

          {/* Circular Grid Container */}
          <div className="flex flex-nowrap sm:flex-wrap justify-center gap-10 sm:gap-6">
            {(topJobLocations.data && topJobLocations.data.length > 0
              ? topJobLocations.data.map((apiLoc: any) => {
                  const staticLoc = LOCATIONS.find(
                    (l) =>
                      l.name.toLowerCase() === apiLoc.city.toLowerCase() ||
                      l.id.toString() === apiLoc.location_id.toString(),
                  );
                  return {
                    name: apiLoc.city,
                    count: apiLoc.total_jobs + "+",
                    id: apiLoc.location_id,
                    image: staticLoc?.image || Ahmedabad, // Fallback to Ahmedabad if no image found
                  };
                })
              : LOCATIONS
            ).map((loc, idx) => (
              <Link
                to={`/explore-job?type=location&id=${loc.id}`}
                // to={`/explore-job?search=${loc.name}&type=location&id=${loc.id}`}
                key={idx}
              >
                <div className="group flex flex-col items-center cursor-pointer">
                  {/* Circle Image Container */}
                  <div className="relative w-32 h-32 sm:w-24 sm:h-24 rounded-full p-1 bg-white border-2 border-slate-100 group-hover:border-blue-500 group-hover:shadow-[0_0_0_4px_rgba(59,130,246,0.1)] transition-all duration-300">
                    <div className="w-full h-full rounded-full overflow-hidden relative">
                      <img
                        src={loc.image}
                        alt={loc.name}
                        className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                      />
                      {/* Gradient Overlay */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-60 group-hover:opacity-40 transition-opacity"></div>

                      {/* Count Badge Inside (Optional style, or keep clean) */}
                      <div className="absolute bottom-2 left-0 right-0 text-center">
                        <span className="text-[10px] font-bold text-white bg-black/40 px-2 py-0.5 rounded-full backdrop-blur-sm">
                          {loc.count}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Label */}
                  <div className="mt-3 text-center">
                    <h3 className="font-bold text-slate-800 text-base sm:text-sm group-hover:text-blue-600 transition-colors">
                      {loc.name}
                    </h3>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Tranding Jobs */}

      {/* Tech/AI-ML */}
      <section className={`py-16 bg-white`}>
        <div className="max-w-7xl mx-auto px-4 xl:px-6 sm:px-8">
          <div className="flex justify-between items-end mb-10">
            <div>
              <h2 className="text-3xl sm:text-2xl font-bold text-slate-900">
                Trending Tech & AI-ML Jobs
              </h2>
              <div className="h-1 w-20 bg-blue-500 mt-2 rounded-full"></div>
            </div>
            <Link
              to="/freshers-job"
              className="flex sm:hidden items-center gap-1 text-blue-600 font-semibold hover:text-blue-700 transition"
            >
              View All Jobs <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          {/* <div className="grid grid-cols-4 gap-[32px] xsm:grid-cols-1 sm:grid-cols-2 sm  sm:gap-[20px]"> */}
          <div className="grid grid-cols-3 sm:grid-cols-2 xsm:grid-cols-1 gap-6">
            {feshersJobs.data?.slice(0, 6).map((job) => {
              // console.log("Job AI ML:", job);
              return <GovJobs {...job} key={job.id} />;
            })}
          </div>

          <div className="mt-8 text-center hidden sm:block">
            <Link
              to="/freshers-job"
              className="inline-flex items-center gap-2 text-blue-600 font-semibold border border-blue-200 px-6 py-3 rounded-full hover:bg-blue-50 transition"
            >
              View All Jobs <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* Core Engg/Embedded */}

      <section className={`py-16 bg-white`}>
        <div className="max-w-7xl mx-auto px-4 xl:px-6 sm:px-8">
          <div className="flex justify-between items-end mb-10">
            <div>
              <h2 className="text-3xl sm:text-2xl font-bold text-slate-900">
                Core Engineering & Embedded Systems
              </h2>
              <div className="h-1 w-20 bg-blue-500 mt-2 rounded-full"></div>
            </div>
            <Link
              to="/freshers-job"
              className="flex sm:hidden items-center gap-1 text-blue-600 font-semibold hover:text-blue-700 transition"
            >
              View All Jobs <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          {/* <div className="grid grid-cols-4 gap-[32px] xsm:grid-cols-1 sm:grid-cols-2 sm  sm:gap-[20px]"> */}
          <div className="grid grid-cols-3 sm:grid-cols-2 xsm:grid-cols-1 gap-6">
            {engineerJobs?.data?.data?.map((job) => {
              // console.log("Job Core enginering:", job);
              return <GovJobs {...job} key={job.id} />;
            })}
          </div>

          <div className="mt-8 text-center hidden sm:block">
            <Link
              to="/freshers-job"
              className="inline-flex items-center gap-2 text-blue-600 font-semibold border border-blue-200 px-6 py-3 rounded-full hover:bg-blue-50 transition"
            >
              View All Jobs <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* MBA/Commerce */}

      <section className={`py-16 bg-white`}>
        <div className="max-w-7xl mx-auto px-4 xl:px-6 sm:px-8">
          <div className="flex justify-between items-end mb-10">
            <div>
              <h2 className="text-3xl sm:text-2xl font-bold text-slate-900">
                Management & Commerce Opportunities
              </h2>
              <div className="h-1 w-20 bg-blue-500 mt-2 rounded-full"></div>
            </div>
            <Link
              to="/freshers-job"
              className="flex sm:hidden items-center gap-1 text-blue-600 font-semibold hover:text-blue-700 transition"
            >
              View All Jobs <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          {/* <div className="grid grid-cols-4 gap-[32px] xsm:grid-cols-1 sm:grid-cols-2 sm  sm:gap-[20px]"> */}
          <div className="grid grid-cols-3 sm:grid-cols-2 xsm:grid-cols-1 gap-6">
            {mbaJobs?.data?.data?.map((job) => {
              // console.log("Job MBA:", job);
              return <GovJobs {...job} key={job.id} />;
            })}
          </div>

          <div className="mt-8 text-center hidden sm:block">
            <Link
              to="/freshers-job"
              className="inline-flex items-center gap-2 text-blue-600 font-semibold border border-blue-200 px-6 py-3 rounded-full hover:bg-blue-50 transition"
            >
              View All Jobs <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* </div> */}

      {/* Latest Jobs */}
      <section className={`py-16 bg-white`}>
        <div className="max-w-7xl mx-auto px-4 xl:px-6 sm:px-8">
          <div className="flex justify-between items-end mb-10">
            <div>
              <h2 className="text-3xl sm:text-2xl font-bold text-slate-900">
                Recently Posted Jobs
              </h2>
              <div className="h-1 w-20 bg-blue-500 mt-2 rounded-full"></div>
            </div>
            <Link
              to="/freshers-job"
              className="flex sm:hidden items-center gap-1 text-blue-600 font-semibold hover:text-blue-700 transition"
            >
              View All Jobs <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="flex flex-col gap-4">
            {latestJobs.data?.map((job) => {
              // console.log("Job Latest:", job);
              return <LatestJobs {...job} key={job.id} />;
            })}
          </div>

          <div className="mt-8 text-center hidden sm:block">
            <Link
              to="/freshers-job"
              className="inline-flex items-center gap-2 text-blue-600 font-semibold border border-blue-200 px-6 py-3 rounded-full hover:bg-blue-50 transition"
            >
              View All Jobs <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 xsm:px-4 mb-8 overflow-hidden">
        <div className="grid grid-cols-12 sm:grid-cols-1 gap-12 xl:gap-8 xsm:gap-6 items-start">
          {/* Freshment at a Glance Column */}
          <div className="col-span-7 sm:col-span-12 space-y-8 min-w-0">
            <div className="min-w-0 w-full">
              <span className="text-[10px] font-black uppercase tracking-widest text-brand-600 bg-brand-50 px-3 py-1 rounded-md border border-brand-100">
                Ecosystem Metrics
              </span>
              <h2 className="text-3xl xl:text-2xl xsm:text-xl font-black text-slate-900 tracking-tight mt-3 break-words">
                Freshment at a Glance
              </h2>
              <p className="text-slate-500 text-sm xl:text-xs xsm:text-[10px] font-medium mt-1 break-all">
                Driving active career transformation and democratized hiring
                across standard benchmarks.
              </p>
            </div>

            <div className="min-w-0">
              <div className="grid grid-cols-2 xsm:grid-cols-1 gap-4 xl:gap-3 xsm:gap-2">
                {glanceItems.map((item, idx) => {
                  const IconComponent = item.icon;
                  return (
                    <div
                      key={idx}
                      className="bg-white border border-slate-100 p-5 xl:p-4 xsm:p-3 rounded-2xl flex items-start gap-4 xl:gap-3 xsm:gap-2 hover:shadow-md transition duration-300 overflow-hidden"
                    >
                      <div
                        className={`p-3 rounded-xl border shrink-0 ${item.color}`}
                      >
                        <IconComponent className="w-5 h-5" />
                      </div>
                      <div className="min-w-0">
                        <div className="text-xl xl:text-lg xsm:text-base font-bold text-slate-900 tracking-tight break-words">
                          {item.value}
                        </div>
                        <div className="text-sm xl:text-xs xsm:text-[10px] font-semibold text-slate-700 mt-0.5 break-words">
                          {item.label}
                        </div>
                        <div className="text-xs xl:text-[10px] xsm:text-[9px] font-medium text-slate-400 mt-0.5 break-words">
                          {item.subtitle}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Backed By Govt Box */}
            <div className="bg-white border border-emerald-100/80 p-6 xl:p-4 xsm:p-3 rounded-3xl flex items-start gap-4 xl:gap-3 xsm:gap-2 shadow-sm hover:shadow-md transition duration-300 overflow-hidden">
              <div className="p-3 bg-emerald-50 text-emerald-600 rounded-xl border border-emerald-200 shrink-0">
                <ShieldCheck className="w-6 h-6" />
              </div>
              <div className="min-w-0 w-full">
                <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 text-[9px] font-black uppercase tracking-wider mb-2 border border-emerald-100">
                  Government Backed
                </span>
                <h4 className="text-base xl:text-sm xsm:text-xs font-black text-slate-900 tracking-tight break-all">
                  National Initiative Support
                </h4>
                <p className="text-sm xl:text-xs xsm:text-[10px] font-bold text-emerald-800 mt-0.5 break-words">
                  Backed By Govt of Gujarat and MeitY GENESIS, Govt Of India
                </p>
                <p className="text-xs xl:text-[10px] xsm:text-[9px] font-semibold text-slate-400 mt-1 break-words">
                  Empowering regional Indian students and connecting local
                  talent with high-growth startup corridors.
                </p>
              </div>
            </div>
          </div>

          {/* Premium Recognition & Validation Container */}
          <div className="col-span-5 sm:col-span-12 bg-white border border-slate-100/80 rounded-[2.5rem] p-8 xl:p-6 xsm:p-4 shadow-sm space-y-8 relative overflow-hidden min-w-0">
            <div className="absolute top-0 right-0 w-32 h-32 bg-amber-500/5 rounded-full blur-3xl pointer-events-none"></div>

            <div className="flex items-center gap-3 min-w-0">
              <div className="p-2.5 bg-amber-500/10 text-amber-600 rounded-2xl border border-amber-500/20 shrink-0">
                <Award className="w-6 h-6 animate-pulse" />
              </div>
              <div className="min-w-0 w-full">
                <h3 className="text-lg xl:text-base xsm:text-sm font-black text-slate-900 tracking-tight break-all">
                  Recognition & Validation
                </h3>
                <p className="text-[10px] uppercase font-bold text-amber-600 tracking-widest break-words xl:text-[9px] xsm:text-[8px]">
                  ECOSYSTEM RECOGNIZED
                </p>
              </div>
            </div>

            <div className="space-y-4">
              {recognitionItems.map((item, idx) => (
                <div
                  key={idx}
                  className="p-4 bg-slate-50/50 border border-slate-100 hover:border-slate-200/80 rounded-2xl transition duration-200 space-y-2 group"
                >
                  <div className="flex items-center justify-between gap-2">
                    <h4 className="text-xs font-black text-slate-800 tracking-tight group-hover:text-brand-600 transition">
                      {item.title}
                    </h4>
                    <span
                      className={`text-[9px] font-extrabold px-2 py-0.5 rounded-full border ${item.colorClass}`}
                    >
                      {item.badge}
                    </span>
                  </div>
                  <p className="text-[11px] font-medium text-slate-500 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>

            <div className="pt-5 border-t border-slate-100 flex items-center justify-between gap-2">
              <span className="flex items-center gap-1.5 text-[10px] font-bold text-slate-400 uppercase tracking-wider min-w-0">
                <ShieldCheck className="w-4 h-4 text-emerald-500 shrink-0" />{" "}
                Verified Compliance Status
              </span>
              <span className="inline-flex items-center px-2 py-1 rounded bg-emerald-500/10 text-emerald-700 text-[9px] font-black uppercase tracking-wider shrink-0">
                Active 100%
              </span>
            </div>
          </div>
        </div>
      </div>

      <section className="py-12 bg-blue-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 xsm:px-8">
          <div className="grid grid-cols-3 xsm:grid-cols-1 gap-8 divide-x divide-blue-800 xsm:divide-x-0 xsm:divide-y">
            {PLATFORM_STATS.map((stat) => (
              <div
                key={stat.id}
                className="flex flex-col items-center justify-center p-4 text-center"
              >
                <div className="bg-blue-800 p-3 rounded-full mb-4">
                  <stat.icon className="w-8 h-8 text-blue-300" />
                </div>
                <div className="text-4xl font-extrabold mb-2 tracking-tight">
                  {stat.value}
                </div>
                <div className="text-blue-200 font-medium text-lg">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* how it works */}
      <section className="pt-24 pb-14 bg-white">
        <div className="max-w-7xl mx-auto px-8 xl:px-6 xsm:px-4">
          <div className="text-center mb-20">
            <div className="inline-block px-4 py-1.5 rounded-full bg-slate-100 text-slate-600 text-xs font-bold uppercase tracking-wider mb-4 border border-slate-200">
              Simple Process
            </div>
            <h2 className="text-4xl font-black text-slate-900 mb-4 tracking-tight">
              How <span className="text-blue-600">Freshment</span> Works
            </h2>
            <p className="text-lg text-slate-500 max-w-2xl mx-auto">
              Whether you're a student looking for your first break or an
              employer hunting for top talent, we've simplified the journey.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-1 gap-24 xl:gap-16 relative">
            {/* Vertical Divider for Desktop */}
            <div className="block xl:hidden absolute left-1/2 top-0 bottom-0 w-px bg-slate-100 -ml-0.5"></div>

            {/* Candidate Flow */}
            <div className="relative group">
              <div
                className="absolute left-8 bottom-0 w-0.5 bg-gradient-to-b from-blue-100 to-transparent"
                style={{ top: "16%" }}
              ></div>

              <div className="flex items-center gap-4 mb-10 pl-2">
                <div className="w-12 h-12 rounded-2xl bg-blue-50 flex items-center justify-center shadow-sm border border-blue-100">
                  <UserPlus className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="text-2xl font-extrabold text-slate-900">
                    For Candidates
                  </h3>
                  <p className="text-sm text-slate-500 font-medium">
                    Get hired in 4 simple steps
                  </p>
                </div>
              </div>

              <div className="space-y-10 pl-2">
                {/* Step 1 */}
                <div className="relative flex items-start group/item">
                  <div
                    className="absolute  w-4 h-4 rounded-full bg-blue-600 border-4 border-white shadow-sm dot z-10 mt-6 group-hover/item:scale-125 transition-transform"
                    style={{ left: "3%" }}
                  ></div>
                  <div className="ml-16 p-6 w-full rounded-2xl border border-slate-100 bg-white shadow-[0_4px_20px_rgba(0,0,0,0.02)] hover:shadow-[0_10px_30px_rgba(37,99,235,0.08)] hover:border-blue-100 transition-all duration-300">
                    <h4 className="text-lg font-bold text-slate-900 mb-2 flex items-center gap-2">
                      <span className="w-6 h-6 rounded-full bg-blue-50 text-blue-600 text-xs flex items-center justify-center">
                        1
                      </span>
                      Create Profile
                    </h4>
                    <p className="text-slate-600 text-sm leading-relaxed">
                      Sign up and build your professional profile to showcase
                      your skills and resume to top recruiters.
                    </p>
                  </div>
                </div>

                {/* Step 2 */}
                <div className="relative flex items-start group/item">
                  <div
                    className="absolute  w-4 h-4 rounded-full bg-blue-600 border-4 border-white shadow-sm z-10 mt-6 group-hover/item:scale-125 transition-transform dot"
                    style={{ left: "3%" }}
                  ></div>
                  <div className="ml-16 p-6 w-full rounded-2xl border border-slate-100 bg-white shadow-[0_4px_20px_rgba(0,0,0,0.02)] hover:shadow-[0_10px_30px_rgba(37,99,235,0.08)] hover:border-blue-100 transition-all duration-300">
                    <h4 className="text-lg font-bold text-slate-900 mb-2 flex items-center gap-2">
                      <span className="w-6 h-6 rounded-full bg-blue-50 text-blue-600 text-xs flex items-center justify-center">
                        2
                      </span>
                      Search Jobs
                    </h4>
                    <p className="text-slate-600 text-sm leading-relaxed">
                      Browse through thousands of verified jobs filtered by
                      location, skills, and salary expectations.
                    </p>
                  </div>
                </div>

                {/* Step 3 */}
                <div className="relative flex items-start group/item">
                  <div
                    className="absolute  w-4 h-4 rounded-full bg-blue-600 border-4 border-white shadow-sm z-10 mt-6 group-hover/item:scale-125 transition-transform dot"
                    style={{ left: "3%" }}
                  ></div>
                  <div className="ml-16 p-6 w-full rounded-2xl border border-slate-100 bg-white shadow-[0_4px_20px_rgba(0,0,0,0.02)] hover:shadow-[0_10px_30px_rgba(37,99,235,0.08)] hover:border-blue-100 transition-all duration-300">
                    <h4 className="text-lg font-bold text-slate-900 mb-2 flex items-center gap-2">
                      <span className="w-6 h-6 rounded-full bg-blue-50 text-blue-600 text-xs flex items-center justify-center">
                        3
                      </span>
                      Apply Instantly
                    </h4>
                    <p className="text-slate-600 text-sm leading-relaxed">
                      One-click apply to multiple companies. Track your
                      application status in real-time on the dashboard.
                    </p>
                  </div>
                </div>

                {/* Step 4 */}
                <div className="relative flex items-start group/item">
                  <div
                    className="absolute  w-4 h-4 rounded-full bg-blue-600 border-4 border-white shadow-sm z-10 mt-6 group-hover/item:scale-125 transition-transform dot"
                    style={{ left: "3%" }}
                  ></div>
                  <div className="ml-16 p-6 w-full rounded-2xl border border-slate-100 bg-white shadow-[0_4px_20px_rgba(0,0,0,0.02)] hover:shadow-[0_10px_30px_rgba(37,99,235,0.08)] hover:border-blue-100 transition-all duration-300">
                    <h4 className="text-lg font-bold text-slate-900 mb-2 flex items-center gap-2">
                      <span className="w-6 h-6 rounded-full bg-blue-50 text-blue-600 text-xs flex items-center justify-center">
                        4
                      </span>
                      Get Hired
                    </h4>
                    <p className="text-slate-600 text-sm leading-relaxed">
                      Attend interviews, receive offer letters, and kickstart
                      your dream career with top companies.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Employer Flow - Improved Design */}
            <div className="relative group">
              <div
                className="absolute left-8 bottom-0 w-0.5 bg-gradient-to-b from-blue-100 to-transparent"
                style={{ top: "16%" }}
              ></div>

              <div className="flex items-center gap-4 mb-10 pl-2">
                <div className="w-12 h-12 rounded-2xl bg-indigo-50 flex items-center justify-center shadow-sm border border-indigo-100">
                  <Building className="w-6 h-6 text-indigo-600" />
                </div>
                <div>
                  <h3 className="text-2xl font-extrabold text-slate-900">
                    For Employers
                  </h3>
                  <p className="text-sm text-slate-500 font-medium">
                    Hire top talent in minutes
                  </p>
                </div>
              </div>

              <div className="space-y-10 pl-2">
                {/* Step 1 */}
                <div className="relative flex items-start group/item">
                  <div
                    className="absolute  w-4 h-4 rounded-full bg-blue-600 border-4 border-white shadow-sm z-10 mt-6 group-hover/item:scale-125 transition-transform dot"
                    style={{ left: "3%" }}
                  ></div>
                  <div className="ml-16 p-6 w-full rounded-2xl border border-slate-100 bg-white shadow-[0_4px_20px_rgba(0,0,0,0.02)] hover:shadow-[0_10px_30px_rgba(79,70,229,0.08)] hover:border-indigo-100 transition-all duration-300">
                    <h4 className="text-lg font-bold text-slate-900 mb-2 flex items-center gap-2">
                      <span className="w-6 h-6 rounded-full bg-indigo-50 text-indigo-600 text-xs flex items-center justify-center">
                        1
                      </span>
                      Register Company
                    </h4>
                    <p className="text-slate-600 text-sm leading-relaxed">
                      Create your verified company profile. It takes less than 2
                      minutes to get started.
                    </p>
                  </div>
                </div>

                {/* Step 2 - Highlighted */}
                <div className="relative flex items-start group/item">
                  <div
                    className="absolute  w-4 h-4 rounded-full bg-blue-600 border-4 border-white shadow-sm z-10 mt-6 group-hover/item:scale-125 transition-transform dot"
                    style={{ left: "3%" }}
                  ></div>
                  <div className="ml-16 p-6 w-full rounded-2xl border border-indigo-200 bg-gradient-to-r from-indigo-50/80 to-white shadow-[0_4px_20px_rgba(79,70,229,0.05)] hover:shadow-[0_10px_30px_rgba(79,70,229,0.12)] hover:border-indigo-300 transition-all duration-300 relative overflow-hidden">
                    <div className="absolute top-0 right-0 bg-orange-500 text-white text-[10px] font-bold px-3 py-1 rounded-bl-xl shadow-sm z-10">
                      BEST VALUE
                    </div>
                    <h4 className="text-lg font-bold text-slate-900 mb-2 pr-4 flex items-start gap-2">
                      <span className="w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs flex-shrink-0 flex items-center justify-center mt-0.5">
                        2
                      </span>
                      <span>Post 3 Jobs for FREE & Get Resume Credits</span>
                    </h4>
                    <p className="text-slate-700 text-sm leading-relaxed font-medium">
                      Post 3 job openings without any hidden charges. Unlock
                      database access to contact candidates directly.
                    </p>
                  </div>
                </div>

                {/* Step 3 */}
                <div className="relative flex items-start group/item">
                  <div
                    className="absolute  w-4 h-4 rounded-full bg-blue-600 border-4 border-white shadow-sm z-10 mt-6 group-hover/item:scale-125 transition-transform dot"
                    style={{ left: "3%" }}
                  ></div>
                  <div className="ml-16 p-6 w-full rounded-2xl border border-slate-100 bg-white shadow-[0_4px_20px_rgba(0,0,0,0.02)] hover:shadow-[0_10px_30px_rgba(79,70,229,0.08)] hover:border-indigo-100 transition-all duration-300">
                    <h4 className="text-lg font-bold text-slate-900 mb-2 flex items-center gap-2">
                      <span className="w-6 h-6 rounded-full bg-indigo-50 text-indigo-600 text-xs flex items-center justify-center">
                        3
                      </span>
                      Access Talent from 2500+ Colleges
                    </h4>
                    <p className="text-slate-600 text-sm leading-relaxed">
                      Connect directly with a massive pool of verified freshers
                      from top colleges across India.
                    </p>
                  </div>
                </div>

                {/* Step 4 */}
                <div className="relative flex items-start group/item">
                  <div
                    className="absolute  w-4 h-4 rounded-full bg-blue-600 border-4 border-white shadow-sm z-10 mt-6 group-hover/item:scale-125 transition-transform dot"
                    style={{ left: "3%" }}
                  ></div>
                  <div className="ml-16 p-6 w-full rounded-2xl border border-slate-100 bg-white shadow-[0_4px_20px_rgba(0,0,0,0.02)] hover:shadow-[0_10px_30px_rgba(79,70,229,0.08)] hover:border-indigo-100 transition-all duration-300">
                    <h4 className="text-lg font-bold text-slate-900 mb-2 flex items-center gap-2">
                      <span className="w-6 h-6 rounded-full bg-indigo-50 text-indigo-600 text-xs flex items-center justify-center">
                        4
                      </span>
                      Hire Quickly
                    </h4>
                    <p className="text-slate-600 text-sm leading-relaxed">
                      Use our smart filters to shortlist candidates, schedule
                      interviews, and close positions in record time.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* trusted by */}
      {/* <section className="py-16 bg-white border-t border-slate-100 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 xl:px-6 sm:px-8 text-center mb-12">
          <h3 className="text-slate-400 font-bold text-sm xsm:text-xs uppercase tracking-[0.2em]">
            Trusted By & Partnered With
          </h3>
        </div>

     
        <div className="relative w-full overflow-hidden">
       
          <div className="absolute top-0 left-0 z-10 w-40 sm:w-20 h-full bg-gradient-to-r from-white to-transparent"></div>
          <div className="absolute top-0 right-0 z-10 w-40 sm:w-20 h-full bg-gradient-to-l from-white to-transparent"></div>

       
          <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">

            <div className="flex items-center gap-24 sm:gap-12 px-12 sm:px-6">
              {PARTNERS.map((partner) => (
                <div
                  key={`p1-${partner.id}`}
                  className="group flex items-center gap-3 opacity-50 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-500 cursor-default"
                >
                  <div className="p-2 bg-slate-100 rounded-lg group-hover:bg-blue-50 transition-colors">
                    <partner.icon className="w-8 h-8 sm:w-6 sm:h-6 text-slate-600 group-hover:text-blue-600" />
                  </div>
                  <span className="text-xl sm:text-lg font-bold text-slate-700 group-hover:text-slate-900 whitespace-nowrap">
                    {partner.name}
                  </span>
                </div>
              ))}
            </div>

          
            <div className="flex items-center gap-24 sm:gap-12 px-12 sm:px-6">
              {PARTNERS.map((partner) => (
                <div
                  key={`p2-${partner.id}`}
                  className="group flex items-center gap-3 opacity-50 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-500 cursor-default"
                >
                  <div className="p-2 bg-slate-100 rounded-lg group-hover:bg-blue-50 transition-colors">
                    <partner.icon className="w-8 h-8 sm:w-6 sm:h-6 text-slate-600 group-hover:text-blue-600" />
                  </div>
                  <span className="text-xl sm:text-lg font-bold text-slate-700 group-hover:text-slate-900 whitespace-nowrap">
                    {partner.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <style>{`
    @keyframes marquee {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }
    .animate-marquee {
      animation: marquee 40s linear infinite;
    }
  `}</style>
      </section> */}

      {/* trusted by from talent connect */}
      {/* <div className="my-24">
        <div className="max-w-7xl mx-auto ">
          <p className="text-center text-sm font-semibold text-gray-500 mb-10 uppercase tracking-widest">
            Trusted by High-Growth Startups
          </p>
          <div className="flex flex-wrap justify-center items-center gap-y-8 gap-x-16 px-4">
            {companies.map((name, i) => (
              <div key={i}>
                <span className="text-2xl font-bold cursor-pointer text-gray-400  transition-colors duration-300 ease-in-out hover:text-black">
                  {name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* supported by from talent connect */}

      <div
        className="px-4 relative max-w-7xl mx-auto my-14"
        style={{ zIndex: 1 }}
      >
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-3 mb-10 supported-by-header">
            <div
              className="flex-1"
              style={{
                height: "2px",
                background: "linear-gradient(to right, transparent, #d1d5db)",
                width: "48px",
              }}
            ></div>
            <span
              className="text-sm font-bold text-gray-500 uppercase px-2"
              style={{ letterSpacing: "0.1em", fontSize: "0.875rem" }}
            >
              Supported & Incubated By
            </span>
            <div
              className="flex-1"
              style={{
                height: "2px",
                background: "linear-gradient(to left, transparent, #d1d5db)",
                width: "48px",
              }}
            ></div>
          </div>

          <style>
            {`
        .marquee-swiper .swiper-wrapper {
          transition-timing-function: linear !important;
        }
      `}
          </style>
          <Swiper
            className="marquee-swiper container"
            style={{ width: "100%", height: "100px" }}
            modules={[Autoplay]}
            spaceBetween={50}
            slidesPerView={5}
            loop={true}
            speed={5000}
            allowTouchMove={false}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            breakpoints={{
              320: { slidesPerView: 1 },
              480: { slidesPerView: 2 },
              640: { slidesPerView: 3 },
              960: { slidesPerView: 4 },
              1140: { slidesPerView: 5 },
            }}
          >
            {supportersImage.map((si) => (
              <SwiperSlide
                key={si.name}
                className="flex justify-center items-center"
              >
                <img
                  src={si.src}
                  alt={si.name}
                  style={{
                    height: "56px",
                    width: "300px",
                    objectFit: "contain",
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {/* Startup odisha */}
      <section className="py-16 bg-slate-900 text-white relative overflow-hidden border-t border-slate-800">
        <div className="absolute top-0 right-0 w-80 h-80 bg-orange-500/10 rounded-full blur-[100px] pointer-events-none -mr-40 -mt-20"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="flex flex-row sm:flex-col justify-between items-start sm:items-start items-center gap-8">
            <div className="text-left ">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-[10px] font-black uppercase tracking-widest rounded-full mb-4 shadow-sm shadow-orange-500/10">
                State Partnership Active
              </span>
              <h3 className="text-3xl md:text-4xl font-black tracking-tight leading-tight mb-4 text-white">
                Talent Connect × Startup Odisha
              </h3>
              <p className="text-slate-350 font-medium max-w-3xl leading-relaxed text-lg md:text-sm">
                Driving innovation state-wide by collaborating with{" "}
                <span className="text-orange-400 font-bold">
                  2,000+ startups
                </span>{" "}
                under{" "}
                <span className="text-orange-400 font-bold">
                  3 tailored phases
                </span>
                . Read official founder reviews, review structural roadmap
                timelines, and apply directly to specialized startup
                opportunities.
              </p>
            </div>
            <div className="flex justify-end">
              <Link to="/startup-odisha">
                <button className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-extrabold px-6 py-4 rounded-xl shadow-lg shadow-orange-500/20 active:scale-95 transition-transform">
                  Explore Odisha Drive
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
                  </span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* features */}
      <section className="py-24 bg-white relative overflow-hidden">
        {/* Background Decor */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-30 pointer-events-none">
          <div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-blue-50 rounded-full blur-3xl"></div>
          <div className="absolute bottom-[-10%] right-[-10%] w-[500px] h-[500px] bg-indigo-50 rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 xl:px-6 sm:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <div className="inline-block px-4 py-1.5 rounded-full bg-slate-100 text-slate-600 text-sm font-bold uppercase tracking-wider mb-4 border border-slate-200">
              Why Choose Freshment?
            </div>
            <h2 className="text-4xl font-extrabold text-slate-900 tracking-tight mb-4">
              Built for Your{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                Career Growth
              </span>
            </h2>
            <p className="text-lg text-slate-600">
              We bridge the gap between education and employment with features
              designed for your success.
            </p>
          </div>

          <div className="grid grid-cols-4 sm:grid-cols-2 xsm:grid-cols-1 gap-6">
            {features.map((feature) => (
              <div
                key={feature.id}
                className={`group bg-white p-8 rounded-3xl shadow-sm border border-slate-100 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 ${feature.border}`}
              >
                <div
                  className={`w-14 h-14 ${feature.bg} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}
                >
                  <feature.icon className={`w-7 h-7 ${feature.color}`} />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-blue-600 transition-colors">
                  {feature.title}
                </h3>
                <p className="text-slate-500 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* app download */}
      <section
        id="freshment-app"
        className="py-24 bg-slate-900 relative overflow-hidden"
      >
        {/* Animated Background Elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/20 rounded-full blur-[100px] animate-pulse"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-indigo-500/20 rounded-full blur-[100px] animate-pulse delay-1000"></div>
        </div>

        <div className="max-w-7xl mx-auto px-8 xl:px-6 xsm:px-4 relative z-10">
          <div className="flex flex-row xl:flex-col items-center gap-16">
            {/* Content Left */}
            <div className="w-1/2 xl:w-full text-left xl:text-center">
              <h2 className="text-5xl xl:text-4xl font-black text-white leading-tight mb-6">
                Start Your Career with the{" "}
                <span className="text-blue-400">Right Job</span>
              </h2>
              <p className="text-lg text-slate-400 mb-8 max-w-xl mx-0 xl:mx-auto">
                Get real-time job alerts, track your applications, and chat
                directly with recruiters. Your dream career is just a tap away.
              </p>

              <div className="flex flex-row xsm:flex-col gap-4 justify-start xl:justify-center">
                <Link
                  to="https://play.google.com/store/apps/details?id=com.govtjobs.naukari"
                  target="_blank"
                >
                  <button className="flex items-center justify-center gap-3 bg-white text-slate-900 px-8 py-4 rounded-xl font-bold text-lg hover:bg-slate-100 transition shadow-[0_0_20px_rgba(255,255,255,0.3)] hover:scale-105 active:scale-95">
                    <Download className="w-6 h-6" />
                    Download App
                  </button>
                </Link>
                <Link to="/freshment-app">
                  <button className="flex items-center justify-center gap-3 bg-white/10 text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-white/20 transition backdrop-blur-md border border-white/10">
                    <Sparkles className="w-5 h-5 text-blue-400" />
                    Explore Features
                  </button>
                </Link>
              </div>

              <div className="mt-8 flex items-center justify-start xl:justify-center gap-4">
                <div className="flex -space-x-3">
                  <div className="w-10 h-10 rounded-full bg-slate-600 border-2 border-slate-900 flex items-center justify-center text-xs font-bold text-white">
                    2L+
                  </div>
                  <img
                    className="w-10 h-10 rounded-full border-2 border-slate-900"
                    src="https://i.pravatar.cc/100?img=33"
                    alt="User"
                  />
                  <img
                    className="w-10 h-10 rounded-full border-2 border-slate-900"
                    src="https://i.pravatar.cc/100?img=47"
                    alt="User"
                  />
                </div>
                <div className="text-left">
                  <div className="text-white font-bold">
                    Join 2 Lakh+ Freshers
                  </div>
                  <div className="text-slate-400 text-xs">
                    Rated 4.8/5 on Play Store
                  </div>
                </div>
              </div>
            </div>

            {/* Visual Right - CSS Phone Mockup */}
            <div className="w-1/2 xl:w-full flex justify-end xl:justify-center">
              <div className="relative w-[300px] h-[600px] bg-slate-800 rounded-[3rem] border-8 border-slate-700 shadow-2xl overflow-hidden rotate-[-6deg] hover:rotate-0 transition-transform duration-500">
                {/* Phone Screen */}
                <div className="absolute inset-0 bg-slate-50 overflow-hidden">
                  {/* Header */}
                  <div className="h-20 bg-blue-600 p-6 flex justify-between items-end">
                    <div className="w-8 h-8 bg-white/20 rounded-full"></div>
                    <div className="w-24 h-4 bg-white/20 rounded-full"></div>
                  </div>
                  {/* Job Cards Mockup */}
                  <div className="p-4 space-y-4">
                    <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100 flex gap-3 items-center transform translate-y-4 opacity-0 animate-[slideIn_0.5s_forwards_0.2s]">
                      <div className="w-10 h-10 bg-indigo-100 rounded-lg"></div>
                      <div className="flex-1">
                        <div className="w-3/4 h-3 bg-slate-200 rounded mb-2"></div>
                        <div className="w-1/2 h-2 bg-slate-100 rounded"></div>
                      </div>
                    </div>
                    <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100 flex gap-3 items-center transform translate-y-4 opacity-0 animate-[slideIn_0.5s_forwards_0.4s]">
                      <div className="w-10 h-10 bg-green-100 rounded-lg"></div>
                      <div className="flex-1">
                        <div className="w-2/3 h-3 bg-slate-200 rounded mb-2"></div>
                        <div className="w-1/3 h-2 bg-slate-100 rounded"></div>
                      </div>
                      <div className="px-2 py-1 bg-green-100 text-[10px] text-green-700 font-bold rounded">
                        APPLIED
                      </div>
                    </div>
                    <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100 flex gap-3 items-center transform translate-y-4 opacity-0 animate-[slideIn_0.5s_forwards_0.6s]">
                      <div className="w-10 h-10 bg-orange-100 rounded-lg"></div>
                      <div className="flex-1">
                        <div className="w-4/5 h-3 bg-slate-200 rounded mb-2"></div>
                        <div className="w-1/2 h-2 bg-slate-100 rounded"></div>
                      </div>
                    </div>
                  </div>
                  {/* Floating Notification */}
                  <div className="absolute bottom-10 left-4 right-4 bg-slate-900 text-white p-4 rounded-xl shadow-xl flex items-center gap-3 animate-bounce [animation-duration:3s]">
                    <CheckCircle2 className="w-5 h-5 text-green-400" />
                    <div>
                      <div className="text-xs text-slate-400">Just now</div>
                      <div className="font-bold text-sm">
                        Interview Scheduled!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Inline Style for Animations */}
        <style>{`
    @keyframes slideIn {
      to { transform: translateY(0); opacity: 1; }
    }
  `}</style>
      </section>

      {/* EMPLOYER - TALENT CONNECT (Professional) */}
      <section className="py-20 bg-slate-50 border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-8 xl:px-6 xsm:px-4 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-slate-200 shadow-sm text-slate-600 text-xs font-bold uppercase tracking-wider mb-8">
            <Building2 className="w-3 h-3 text-blue-600" />
            For Employers
          </div>

          <h2 className="text-5xl sm:text-3xl font-extrabold text-slate-900 mb-6">
            Hire Fresh Talent from{" "}
            <span className="text-blue-600">PAN India</span>
          </h2>

          <div className="bg-white p-12 sm:p-8 rounded-3xl border border-slate-200 shadow-xl max-w-5xl mx-auto relative overflow-hidden">
            {/* Pattern Background */}
            <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>

            <div className="relative z-10">
              <div className="flex flex-row sm:flex-col items-center justify-between gap-8 mb-8">
                <div className="flex-1 text-left">
                  <h3 className="text-2xl font-bold text-slate-900 mb-2 flex items-center gap-2">
                    <Rocket className="w-6 h-6 text-blue-600" />
                    Join Talent Connect
                  </h3>
                  <p className="text-slate-600 text-lg leading-relaxed">
                    Designed for Hiring Candidates directly from{" "}
                    <span className="font-bold text-slate-900">Colleges</span>.
                    Specially built for{" "}
                    <span className="font-bold text-slate-900">
                      Startups, MSMEs
                    </span>
                    , and{" "}
                    <span className="font-bold text-slate-900">
                      Mid-sized companies
                    </span>
                    .
                  </p>
                </div>
                <div className="flex-shrink-0">
                  <Link
                    to="https://talentconnect.freshmentapp.com/register/"
                    target="_blank"
                  >
                    <button className="bg-blue-600 text-white text-lg font-bold px-8 py-4 rounded-xl shadow-lg shadow-blue-500/30 hover:bg-blue-700 transition flex items-center gap-2">
                      Start Hiring Now <ArrowRight className="w-5 h-5" />
                    </button>
                  </Link>
                </div>
                <div className="flex-shrink-0">
                  <Link to="/talent-connect">
                    <button className="bg-white text-blue-600 border border-white-600 text-lg font-bold px-8 py-4 rounded-xl shadow-sm hover:bg-blue-50 transition flex items-center justify-center gap-2">
                      Learn More
                    </button>
                  </Link>
                </div>
              </div>

              <div className="grid grid-cols-3 sm:grid-cols-1 gap-4 border-t border-slate-100 pt-8">
                <div className="flex items-center gap-3 text-left p-4 rounded-xl bg-slate-50">
                  <div className="bg-white p-2 rounded-lg border border-slate-200 shadow-sm">
                    <Users className="w-5 h-5 text-blue-600" />
                  </div>
                  <div>
                    <div className="font-bold text-slate-900">
                      500+ Colleges
                    </div>
                    <div className="text-xs text-slate-500">
                      Connected Digitally
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3 text-left p-4 rounded-xl bg-slate-50">
                  <div className="bg-white p-2 rounded-lg border border-slate-200 shadow-sm">
                    <Building2 className="w-5 h-5 text-orange-600" />
                  </div>
                  <div>
                    <div className="font-bold text-slate-900">MSME Focused</div>
                    <div className="text-xs text-slate-500">
                      Tailored Solutions
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3 text-left p-4 rounded-xl bg-slate-50">
                  <div className="bg-white p-2 rounded-lg border border-slate-200 shadow-sm">
                    <Rocket className="w-5 h-5 text-purple-600" />
                  </div>
                  <div>
                    <div className="font-bold text-slate-900">Fast Hiring</div>
                    <div className="text-xs text-slate-500">
                      Close roles in 7 days
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* COLLEGES - EDUCONNECTPRO */}
      <section className="py-20 bg-white border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-8 xl:px-6 xsm:px-4 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-50 border border-slate-200 shadow-sm text-[#FF5F14] text-xs font-bold uppercase tracking-wider mb-8">
            <GraduationCap className="w-3 h-3 text-[#FF5F14]" />
            For Colleges
          </div>

          <h2 className="text-5xl sm:text-3xl font-extrabold text-slate-900 mb-6">
            Join <span className="text-[#FF5F14]">EduConnectPro</span>
          </h2>

          <div className="bg-slate-50 p-12 sm:p-8 rounded-3xl border border-slate-200 shadow-xl max-w-5xl mx-auto relative overflow-hidden">
            {/* Pattern Background */}
            <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>

            <div className="relative z-10">
              <div className="flex flex-row sm:flex-col items-center justify-between gap-8 mb-8">
                <div className="flex-1 text-left">
                  <h3 className="text-2xl font-bold text-slate-900 mb-2">
                    Empower your Placement Cell
                  </h3>
                  <p className="text-slate-600 text-lg leading-relaxed">
                    A smarter, faster way to connect your students with
                    companies. Digitize your placement process today.
                  </p>
                </div>
                <div className="flex flex-row xsm:flex-col gap-4">
                  <Link
                    to="https://forms.gle/RdFKEBEKofCbTX2L6"
                    target="_blank"
                  >
                    <button className="bg-[#FF5F14] text-white text-lg font-bold px-8 py-4 rounded-xl shadow-lg shadow-[#FF5F14]/30 hover:bg-[#FF5F14]/90 transition flex items-center justify-center gap-2">
                      Start Free Trial <ArrowRight className="w-5 h-5" />
                    </button>
                  </Link>
                  <Link to="/edu-connect">
                    <button className="bg-white text-[#FF5F14] border border-[#FF5F14]/30 text-lg font-bold px-8 py-4 rounded-xl shadow-sm hover:bg-orange-50 transition flex items-center justify-center gap-2">
                      Learn More
                    </button>
                  </Link>
                </div>
              </div>

              <div className="grid grid-cols-3 sm:grid-cols-1 gap-4 border-t border-slate-200 pt-8">
                {/* Feature 1 */}
                <div className="flex items-center gap-3 text-left p-4 rounded-xl bg-white border border-slate-100 shadow-sm">
                  <div className="bg-orange-50 p-2 rounded-lg">
                    <Users className="w-5 h-5 text-[#FF5F14]" />
                  </div>
                  <div>
                    <div className="font-bold text-slate-900">
                      300+ HR Leads
                    </div>
                    <div className="text-xs text-slate-500">Every Month</div>
                  </div>
                </div>
                {/* Feature 2 */}
                <div className="flex items-center gap-3 text-left p-4 rounded-xl bg-white border border-slate-100 shadow-sm">
                  <div className="bg-orange-50 p-2 rounded-lg">
                    <Building2 className="w-5 h-5 text-[#FF5F14]" />
                  </div>
                  <div>
                    <div className="font-bold text-slate-900">
                      Company Visibility
                    </div>
                    <div className="text-xs text-slate-500">
                      Showcase Institute
                    </div>
                  </div>
                </div>
                {/* Feature 3 */}
                <div className="flex items-center gap-3 text-left p-4 rounded-xl bg-white border border-slate-100 shadow-sm">
                  <div className="bg-orange-50 p-2 rounded-lg">
                    <TrendingUp className="w-5 h-5 text-[#FF5F14]" />
                  </div>
                  <div>
                    <div className="font-bold text-slate-900">
                      Student Reports
                    </div>
                    <div className="text-xs text-slate-500">
                      Track Placements
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default HomePage;
